export enum LocalizationTargetType {
	NATIONAL = 'national',
	EEA = 'eea',
	INTERNATIONAL = 'international',
	GENERAL = 'general',
	FALLBACK = 'fallback'
}
